/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettingStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    OLD = 'OLD'
}
